import { render, staticRenderFns } from "./LocationDetails.vue?vue&type=template&id=f6b32ace&scoped=true&"
import script from "./LocationDetails.vue?vue&type=script&lang=js&"
export * from "./LocationDetails.vue?vue&type=script&lang=js&"
import style0 from "./LocationDetails.vue?vue&type=style&index=0&id=f6b32ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b32ace",
  null
  
)

export default component.exports